import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reporte-facturacion"
// Opens the PDF in a new tab without submitting a form, avoiding spinner side-effects.
export default class extends Controller {
  static values = { url: String, excelUrl: String }

  generate(event) {
    event.preventDefault()
    window.open(this._buildUrl(this.urlValue), '_blank', 'noopener,noreferrer')
  }

  generateExcel(event) {
    event.preventDefault()
    window.open(this._buildUrl(this.excelUrlValue), '_blank', 'noopener,noreferrer')
  }

  _buildUrl(base) {
    const select = (name) => {
      const el = this.element.querySelector(`[name="${name}"]`)
      return el ? el.value : null
    }

    const params = new URLSearchParams()

    const obraSocial = select('obra_social_codigo')
    const mes        = select('mes')
    const anio       = select('anio')
    const estado     = select('estado')
    const tipoPaciente = select('tipo_paciente')

    if (obraSocial) params.set('obra_social_codigo', obraSocial)
    if (mes)        params.set('mes', mes)
    if (anio)       params.set('anio', anio)
    if (estado)     params.set('estado', estado)
    if (tipoPaciente) params.set('tipo_paciente', tipoPaciente)

    return `${base}?${params.toString()}`
  }
}
